import { Typography } from '@mui/material';
import React from 'react';
import { ErrorReference, GraphQlRequestErrorCode } from '../../../../api/types';
import { Error } from './Error';
import ErrorTechnicalDetails from './ErrorTechnicalDetails';

interface SetupErrorProps {
  // Optional: this screen is also rendered outside the error boundary, where
  // there is no underlying GraphQL error to report.
  errorCode?: GraphQlRequestErrorCode | null;
  errorReference?: ErrorReference | null;
}

const SetupErrorComponent = (props: SetupErrorProps) => {
  const { errorCode = null, errorReference = null } = props;

  return (
    <Error
      title={{ key: 'pages:errorBoundary.setUpError' }}
      message={(t) => (
        <>
          <Typography variant="h5">
            {t('pages:errorBoundary.contactAdministrator')}
          </Typography>
          <ErrorTechnicalDetails
            errorCode={errorCode}
            errorReference={errorReference}
          />
        </>
      )}
    />
  );
};

export default SetupErrorComponent;
